import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_1: FaireProductEntity = {
  token: "caden-lane-1",
  type: "product",
  name: "Sweet Like Candy Two Piece Pajama Set | Pink",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/5eea9df877c84ad7eab100fd21a2d737d866cad5ae59baa4c0981123533ad10e.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1798,1798,x0,y0,safe&width=720",
  priceDollars: 18,
  msrpDollars: 36,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
